import { render, staticRenderFns } from "./retentionRate.vue?vue&type=template&id=1a13ec55&scoped=true"
import script from "./retentionRate.vue?vue&type=script&lang=js"
export * from "./retentionRate.vue?vue&type=script&lang=js"
import style0 from "./retentionRate.vue?vue&type=style&index=0&id=1a13ec55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a13ec55",
  null
  
)

export default component.exports